/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListDiningTableDto } from '../../models/api-response-list-dining-table-dto';
import { DiningTableBulkRequest } from '../../models/dining-table-bulk-request';

export interface BulkCreateDiningTables$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: DiningTableBulkRequest
}

export function bulkCreateDiningTables(http: HttpClient, rootUrl: string, params: BulkCreateDiningTables$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDiningTableDto>> {
  const rb = new RequestBuilder(rootUrl, bulkCreateDiningTables.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListDiningTableDto>;
    })
  );
}

bulkCreateDiningTables.PATH = '/v1/api/dining-tables/bulk-create';
